function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 63.2,
  y: 249.9,
  width: 157.2,
  height: 12.8
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6.4,
  y: 267,
  width: 270.7,
  height: 12.8
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M248.7,59V26.2h-21.9V3.7H56.8v22.4H34.8V59H0v122h34.8v64.6h213.8V181h34.8V59H248.7z M34.8,168.2h-22v-16.9 h22V168.2z M34.8,142.8h-22v-18.6h22V142.8z M34.8,115.7h-22V97.2h22V115.7z M34.8,88.6h-22V71.8h22V88.6z M69.6,16.5h144.4v9.6 H69.6V16.5z M235.9,232.9H47.6V38.9h188.3V232.9z M270.7,168.2h-22v-16.9h22V168.2z M270.7,142.8h-22v-18.6h22V142.8z M270.7,115.7 h-22V97.2h22V115.7z M270.7,88.6h-22V71.8h22V88.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("ellipse", {
  transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -19.1996 24.5243)",
  cx: 95.7,
  cy: 94.7,
  rx: 19,
  ry: 19
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -16.7352 45.6896)",
  cx: 187.8,
  cy: 94.7,
  rx: 19,
  ry: 19
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.8,131.5c20.3,0,36.8-16.5,36.8-36.8s-16.5-36.8-36.8-36.8s-36.8,16.5-36.8,36.8S167.6,131.5,187.8,131.5z  M187.8,66.5c15.6,0,28.3,12.7,28.3,28.3S203.4,123,187.8,123s-28.3-12.7-28.3-28.3S172.3,66.5,187.8,66.5z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70.4,215.6h142.8v-63.9H70.4V215.6z M83.2,164.5h117.3v6.8H83.2V164.5z M83.2,179.8h117.3v7.7H83.2V179.8z  M83.2,196.1h117.3v6.8H83.2V196.1z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M95.7,131.5c20.3,0,36.8-16.5,36.8-36.8S116,57.9,95.7,57.9S58.9,74.4,58.9,94.7S75.4,131.5,95.7,131.5z  M95.7,66.5c15.6,0,28.3,12.7,28.3,28.3S111.3,123,95.7,123s-28.3-12.7-28.3-28.3S80.1,66.5,95.7,66.5z"
});

var SvgTrivie = function SvgTrivie(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrivie, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trivie.93ceee24.svg";
export { ForwardRef as ReactComponent };